export enum formulaireChangementAppartementEnum {
	choixResidence = 'choixResidence',
	ville = 'ville',
	dateArrivee = 'dateArrivee',
	commentaire = 'commentaire',
	profilLocataire = 'profilLocataire',
	familleMonoparental = 'familleMonoparental',
	nbColoc = 'nbColoc',
	nbCopreneurs = 'nbCopreneurs',
	selectionCopreneur = 'selectionCopreneur',
	isBoursier = 'isBoursier',
	isStudent = 'isStudent',
	codePrivilege = "codePrivilege",

	// APPARTEMENT
	nombrePieces = 'nombrePieces',
	nombreChambres = 'nombreChambres',
	espaceExterieur = 'espaceExterieur',
	budgetMaximum = 'budgetMaximum',
	raisonRecherche = 'raisonRecherche',
	raisonRechercheReponse = 'raisonRechercheReponse',

	// PARKING
	typeVehicule = 'typeVehicule',
	longueur = 'longueur',
	largeur = 'largeur',
	hauteur = 'hauteur',
	locationFuturParking = 'locationFuturParking'
}

export enum choixResidenceEnum {
	ouiPreference = 1,
	ouiAbsolument = 2,
	non = 3
}

export enum typeVehiculeEnum {
	voiture = 1,
	moto = 2,
}

// Le mapping se fait en back afin de distinguer les arrondissements des villes
export enum villeEnum {
	paris = 'paris',
	paris1 = 'paris1',
	paris2 = 'paris2',
	paris3 = 'paris3',
	paris8 = 'paris8',
	paris9 = 'paris9',
	paris11 = 'paris11',
	paris12 = 'paris12',
	paris13 = 'paris13',
	paris15 = 'paris15',
	paris16 = 'paris16',
	paris17 = 'paris17',
	paris20 = 'paris20',
	boulogne = 'boulogne',
	courbevoie = 'courbevoie',
	avray = 'avray'
}

export enum nombrePiecesEnum {
	studio = 1,
	piece2 = 2,
	piece3 = 3,
	piece4 = 4,
	piece5 = 5,
	piece6 = 6
}

export enum nombreChambreEnum {
	chambre1 = 1,
	chambre2 = 2,
	chambre3 = 3,
	chambre4 = 4
}

export enum espaceExterieurEnum {
	balcon = 'balcon',
	jardin = 'jardin',
	terrasse = 'terrasse'
}

export enum raisonRechercheEnum {
	sell = 1,
	deposit = 2,
	leave = 3,
	uncomfortable = 4,
	tooSmall = 5,
	tooLarge = 6,
	mutation = 7,
	rupture = 8,
	closerToWork = 9,
	primary = 10,
	rentToHigh = 11,
	unsafe = 12,
	other = 13
}

export enum profilLocataireCRMEnum {
	alone = 1,
	couple = 2,
	family = 3,
	other = 4
}

export enum ouiNonEnum {
	oui = 1,
	non = 0,
}